import React from "react"
import { Link } from "gatsby"

/**CSS */
import "../../styles/ContentMainPage/contentPage.scss"

/** Image */
const test = require("../../../static/images/ic_test.svg") as string
const win = require("../../../static/images/ic_win.svg") as string
const tell = require("../../../static/images/ic_tell.svg") as string
const age = require("../../../static/images/18.svg") as string

/** Components */
import Button from "../../components/Button"
import Paragraph from "../../components/Paragraph"
import BlockItem from "../../components/BlockItem"

export default function ContentPage() {
  return (
    <div className="content-container">
      <div className={"content-wrapper"}>
        <div className={"content-backgroundMain"}></div>

        <Paragraph
          classes={"content-subtitle__addiontal"}
          text={`Пройдите тест от телеканала «Еда» и Триколора и узнайте, как далеко вы
        готовы зайти.`}
        />

        <div className={"content-stage__wrapper"}>
          <BlockItem
            src={test}
            alt={"Тест"}
            text={"Пройдите тест"}
            classImg={"content-stage__image"}
            classPar={"content-stage__text"}
          />

          <BlockItem
            src={tell}
            alt={"Тест"}
            text={"Расскажите друзьям"}
            classImg={"content-stage__image"}
            classPar={"content-stage__text"}
          />

          <BlockItem
            src={win}
            alt={"Тест"}
            text={"Выиграйте приз"}
            classImg={"content-stage__image last"}
            classPar={"content-stage__text"}
          />
        </div>

        <div className={"content-button"}>
          <Link className={"content-link"} to={"/test"}>
            <Button name={"Начать"} className={"animation"} />
          </Link>
        </div>

        <a
          href={"/Правила акции.pdf"}
          target={"_blank"}
          className={"content-conditions"}
        >
          <b>
            <u>Правила акции.</u>
          </b>{" "}
          Общий срок проведения акции «На что Вы готовы ради Еды?»: с 20 января
          по 20 марта 2020 года, период участия и выполнения акционных заданий –
          по 15 февраля 2020 года.
        </a>

        <div className={"test__buttons-imageBlock"}>
          <img
            src={age}
            alt="Ограничение по возрасту"
            className={"test__buttons-image"}
          />
        </div>
      </div>
      <div className={"content-certificate"}>
        <p className={"content-certificate__text"}>
          Свидетельство о регистрации СМИ: ЭЛ № ФС77-50283 от 18 июня 2012 г.
          Выдано Федеральной службой по надзору в сфере связи, информационных
          технологий и массовых коммуникаций (Роскомнадзор).
        </p>
      </div>
    </div>
  )
}
